export class InvoiceAddress {
	WfOfflineID:string = "";
	firstName:string = "";
	lastName:string = "";
	companyName:string = "";
	vatNumber:string = "";
	address:string = "";
	place:string = "";
	postal:string = "";
	country:string = "";
	tel:string = "";
	email:string = "";

	public constructor(data?:any){
		if (!data) return;
		this.WfOfflineID = data.WfOfflineID;
		this.firstName = data.firstName;
		this.lastName = data.lastName;
		this.companyName = data.companyName;
		this.vatNumber = data.vatNumber;
		this.address = data.address;
		this.place = data.place;
		this.postal = data.postal;
		this.country = data.country;
		this.tel = data.tel;
		this.email = data.email;
	}
}